<template>
  <div class="flex">
     <span style="word-break: break-word; white-space: normal">
              <span v-for="(tag, tagIndex) in allTag"
                      :key="tagIndex">
                      <span v-if="tag.tag && tag.tag.name">{{ tag.tag.name }}</span>
                      <span
                        v-if="tagIndex + 1 < allTag.length"
                        >,
                      </span></span>
            </span>
  </div>
</template>
<script>

export default {
  name: 'TagShow',
  mounted () {
    this.allTag = this.params.data[this.params.colDef.cellRendererParams.type]
  },
  data () {
    return {
      allTag: []
     
    }
  }
 
}
</script>
